var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"mt-0",attrs:{"flat":"","ripple":false,"hide-details":"auto","label":_vm.$t('Override field')},model:{value:(_vm.editItemStatus),callback:function ($$v) {_vm.editItemStatus=$$v},expression:"editItemStatus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }